import React, { useState } from 'react';
import { LegalModal, LegalType } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<LegalType | null>(null);
  return <>
      <footer className="py-12 pb-32 md:pb-12 px-4 bg-black text-center border-t border-white/10" data-id="element-213">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-214">
          <p className="text-gold font-serif font-bold tracking-widest text-sm uppercase" data-id="element-215">
            El Azúcar Silencioso · Por Roderic Guillen
          </p>

          <p className="text-sm text-white/40 font-sans max-w-2xl mx-auto leading-relaxed" data-id="element-216">
            Este producto es informativo y educativo. No constituye consejo
            médico ni reemplaza la orientación de un profesional de la salud.
          </p>

          <p className="text-sm text-white/40 font-sans" data-id="element-217">
            Soporte:{' '}
            <a href="mailto:soporte@godeskcore.com" className="text-white/60 hover:text-white transition-colors" data-id="element-218">
              soporte@godeskcore.com
            </a>
          </p>

          <div className="flex items-center justify-center gap-6 pt-4" data-id="element-219">
            <button onClick={() => setOpenModal('privacy')} className="text-sm text-white/40 hover:text-white transition-colors duration-200" data-id="element-220">
              Privacidad
            </button>
            <span className="text-white/20" data-id="element-221">·</span>
            <button onClick={() => setOpenModal('terms')} className="text-sm text-white/40 hover:text-white transition-colors duration-200" data-id="element-222">
              Términos
            </button>
          </div>

          <div className="pt-4 text-xs text-white/30 font-sans" data-id="element-223">
            © 2025 GoDeskCore. Todos los derechos reservados.
          </div>
        </div>
      </footer>

      {openModal && <LegalModal type={openModal} onClose={() => setOpenModal(null)} data-id="element-224" />}
    </>;
}